import { css, jsx } from '@emotion/react';
import { labelStyles, withModifier } from '@zapier/style-encapsulation';
import { Icon } from '../../display/Icon/Icon.es.js';
import { Animation } from '../../../theme/Animation.es.js';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';
import 'react';

const borderWidth = 2;
const Styles = labelStyles("BooleanInput", {
  root: () => [
    css({
      position: "relative",
      display: "inline-block"
    })
  ],
  inner: (props) => [
    css({
      display: "block",
      position: "relative",
      zIndex: 1,
      border: `${borderWidth}px solid ${Colors.GrayWarm6}`,
      backgroundColor: "transparent",
      cursor: "pointer",
      transition: `all ${Animation.transitionDuration} ease-in-out`
    }),
    props.type === "checkbox" && [
      withModifier("checkbox", css({
        width: 18,
        height: 18,
        borderRadius: "var(--zds-radius-none)",
        color: Colors.PrimeWhite
      })),
      props.checked && withModifier("checked", css({
        backgroundColor: `var(--zds-ui-primary-stronger)`,
        borderColor: "transparent"
      })),
      props.isErrored && withModifier("errored", css({
        backgroundColor: props.checked ? `var(--zds-status-error)` : "transparent",
        borderColor: `var(--zds-status-error)`
      })),
      props.disabled && withModifier("disabled", css({
        backgroundColor: props.checked ? Colors.GrayWarm5 : "transparent",
        borderColor: Colors.GrayWarm5,
        cursor: "not-allowed"
      }))
    ],
    props.type === "radio" && [
      withModifier("radio", css({
        color: "transparent",
        width: 20,
        height: 20,
        borderRadius: 20
      })),
      props.checked && withModifier("checked", css({
        borderColor: `var(--zds-ui-primary-stronger)`,
        color: `var(--zds-ui-primary-stronger)`
      })),
      props.isErrored && withModifier("errored", css({
        borderColor: `var(--zds-status-error)`,
        color: `var(--zds-status-error)`
      })),
      props.disabled && withModifier("disabled", css({
        borderColor: Colors.GrayWarm5,
        color: Colors.GrayWarm5,
        cursor: "not-allowed"
      }))
    ]
  ],
  layer: css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: -borderWidth,
    left: -borderWidth,
    width: `calc(100% + ${2 * borderWidth}px)`,
    height: `calc(100% + ${2 * borderWidth}px)`
  })
});
const BooleanInput = ({ type, "aria-label": ariaLabel = void 0, checked = false, disabled = void 0, id = void 0, isErrored = void 0, isRequired = void 0, name = void 0, onChange = () => {
}, tabIndex = 0, value = void 0 }) => {
  const props = {
    type,
    "aria-label": ariaLabel,
    checked,
    disabled,
    id,
    isErrored,
    isRequired,
    name,
    onChange,
    tabIndex,
    value
  };
  return jsx(
    "span",
    { css: Styles.root(), "data-zds": true },
    jsx(
      "span",
      { css: Styles.inner(props), "data-zds": true },
      jsx("input", { "aria-label": ariaLabel, checked, css: Styles.layer, disabled, id, name, onChange, required: isRequired, tabIndex, type, value, "data-zds": true }),
      checked && jsx(
        "span",
        { css: Styles.layer, "data-zds": true },
        jsx(Icon, { isBlock: true, name: {
          checkbox: "formCheck",
          radio: "formRadioDot"
        }[type], size: 18 })
      )
    )
  );
};

export { BooleanInput };
//# sourceMappingURL=BooleanInput.es.js.map
